import axios from "axios";
import { GET_ALL_PENDING_TABLES, DELETE_PENDING_TABLE,
} from "../ActionTypes/pendingTableTypes";

// Récupérer toutes les tables en attente
export const getAllPendingTables = () => async (dispatch) => {
  try {
    const response = await axios.get("/api/PendingTables/getAllPendingTables");
    dispatch({
      type: GET_ALL_PENDING_TABLES,
      payload: response.data, // On met à jour Redux avec la liste des tables
    });
  } catch (error) {
    console.error("Erreur lors de la récupération des tables en attente:", error);
  }
};

// Supprimer une table en attente
export const deletePendingTable = (tableNumber) => async (dispatch) => {
  try {
    await axios.delete(`/api/PendingTables/deletePendingTable/${tableNumber}`);
    dispatch({
      type: DELETE_PENDING_TABLE,
      payload: tableNumber,
    });
  } catch (error) {
    console.error("Erreur lors de la suppression de la table:", error);
  }
};

export const addPendingTable = (tableNumber, additionItems) => async (dispatch, getState) => {
  // Récupérer l'état actuel des tables en attente
  const currentPendingTables = getState().pendingTableReducer;

  // Vérifier si la table existe déjà dans l'état, si non, l'ajouter
  const updatedTables = {
    ...currentPendingTables,
    [tableNumber]: { items: additionItems, status: "locked" },
  };

  // Stocker les tables mises à jour dans le localStorage
  localStorage.setItem("pendingTables", JSON.stringify(updatedTables));

  // Dispatch pour mettre à jour l'état Redux
  dispatch({
    type: "ADD_PENDING_TABLE",
    payload: { tableNumber, items: additionItems },
  });
};



export const lockPendingTable = (table) => ({
  type: "LOCK_PENDING_TABLE",
  payload: table,
});

export const unlockPendingTable = (tableNumber) => ({
  type: "UNLOCK_PENDING_TABLE",
  payload: tableNumber,
});


